import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GrupoClienteModel } from 'app/model/cliente/grupocliente.model';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GrupoclienteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };


  constructor(private httpClient: HttpClient) { }

  getGrupoCliente(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-grupocliente', this.httpOptions)
  }

  getGruposClienteUsuario(page: number, size: number): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL +
      `/view/listar-grupos-cliente-usuario?page=${page}&size=${size}`, this.httpOptions);
  }

  getGruposClienteUsuarioNew(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL +
      '/view/listar-grupos-cliente-usuario', this.httpOptions);
  }

  getPageGrupoCliente(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-grupocliente?page=${page}&size=${size}`, this.httpOptions);
  }

  postGrupoCliente(grupoCliente: GrupoClienteModel): Observable<GrupoClienteModel>{
    return this.httpClient.post<GrupoClienteModel>(this.apiURL + '/new/adicionar-grupocliente', grupoCliente, this.httpOptions);
  }

  deleteGrupoCliente(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/delete-grupocliente/' + id,  { responseType: 'text', headers });
  }

  putGrupoCliente(grupoCliente: GrupoClienteModel): Observable<GrupoClienteModel> {
    return this.httpClient.put<GrupoClienteModel>(this.apiURL + '/edit/editar-grupocliente', grupoCliente, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/grupocliente.service.ts